Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);

var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

Flyout=function(_React$Component){_inherits(Flyout,_React$Component);function Flyout(){_classCallCheck(this,Flyout);return _possibleConstructorReturn(this,(Flyout.__proto__||Object.getPrototypeOf(Flyout)).apply(this,arguments));}_createClass(Flyout,[{key:"componentWillMount",value:function componentWillMount()























{var _calculateAttributes=
this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
this.style=style;
this.path=path;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _calculateAttributes2=
this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
this.style=style;
this.path=path;
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var
datum=props.datum,active=props.active,style=props.style;
return{
style:_helpers2.default.evaluateStyle(style,datum,active),
path:this.getFlyoutPath(props)};

}},{key:"getVerticalPath",value:function getVerticalPath(


props){var
pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,orientation=props.orientation,width=props.width,height=props.height;
var sign=orientation==="top"?1:-1;
var x=props.x+(props.dx||0);
var y=props.y-sign*(props.dy||0);
var pointerEdge=y-sign*pointerLength;
var oppositeEdge=y-sign*pointerLength-sign*height;
var rightEdge=x+width/2;
var leftEdge=x-width/2;
var direction=orientation==="top"?"0 0 0":"0 0 1";
var arc=Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" "+direction;
return"M "+Math.round(x-pointerWidth/2)+", "+Math.round(pointerEdge)+"\n      L "+
Math.round(x)+", "+Math.round(y)+"\n      L "+
Math.round(x+pointerWidth/2)+", "+Math.round(pointerEdge)+"\n      L "+
Math.round(rightEdge-cornerRadius)+", "+Math.round(pointerEdge)+"\n      A "+
arc+" "+Math.round(rightEdge)+", "+Math.round(pointerEdge-sign*cornerRadius)+"\n      L "+
Math.round(rightEdge)+", "+Math.round(oppositeEdge+sign*cornerRadius)+"\n      A "+
arc+" "+Math.round(rightEdge-cornerRadius)+", "+Math.round(oppositeEdge)+"\n      L "+
Math.round(leftEdge+cornerRadius)+", "+Math.round(oppositeEdge)+"\n      A "+
arc+" "+Math.round(leftEdge)+", "+Math.round(oppositeEdge+sign*cornerRadius)+"\n      L "+
Math.round(leftEdge)+", "+Math.round(pointerEdge-sign*cornerRadius)+"\n      A "+
arc+" "+Math.round(leftEdge+cornerRadius)+", "+Math.round(pointerEdge)+"\n      z";

}},{key:"getHorizontalPath",value:function getHorizontalPath(

props){var
pointerLength=props.pointerLength,pointerWidth=props.pointerWidth,cornerRadius=props.cornerRadius,orientation=props.orientation,width=props.width,height=props.height;
var sign=orientation==="right"?1:-1;
var x=props.x+sign*(props.dx||0);
var y=props.y-(props.dy||0);
var pointerEdge=x+sign*pointerLength;
var oppositeEdge=x+sign*pointerLength+sign*width;
var bottomEdge=y+height/2;
var topEdge=y-height/2;
var direction=orientation==="right"?"0 0 0":"0 0 1";
var arc=Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" "+direction;
return"M "+Math.round(pointerEdge)+", "+Math.round(y-pointerWidth/2)+"\n      L "+
Math.round(x)+", "+Math.round(y)+"\n      L "+
Math.round(pointerEdge)+", "+Math.round(y+pointerWidth/2)+"\n      L "+
Math.round(pointerEdge)+", "+Math.round(bottomEdge-cornerRadius)+"\n      A "+
arc+" "+Math.round(pointerEdge+sign*cornerRadius)+", "+Math.round(bottomEdge)+"\n      L "+(
oppositeEdge-sign*cornerRadius)+", "+bottomEdge+"\n      A "+
arc+" "+Math.round(oppositeEdge)+", "+Math.round(bottomEdge-cornerRadius)+"\n      L "+
oppositeEdge+", "+(topEdge+cornerRadius)+"\n      A "+
arc+" "+Math.round(oppositeEdge-sign*cornerRadius)+", "+Math.round(topEdge)+"\n      L "+
Math.round(pointerEdge+sign*cornerRadius)+", "+Math.round(topEdge)+"\n      A "+
arc+" "+Math.round(pointerEdge)+", "+Math.round(topEdge+cornerRadius)+"\n      z";

}},{key:"getFlyoutPath",value:function getFlyoutPath(

props){
var orientation=props.orientation||"top";
return orientation==="left"||orientation==="right"?
this.getHorizontalPath(props):this.getVerticalPath(props);
}},{key:"renderFlyout",value:function renderFlyout(


path,style,events){var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
return(
_react2.default.createElement("path",_extends({
className:className,
d:path,
style:style,
shapeRendering:shapeRendering||"auto",
role:role||"presentation"},
events)));


}},{key:"render",value:function render()

{
return this.renderFlyout(this.path,this.style,this.props.events);
}}]);return Flyout;}(_react2.default.Component);Flyout.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,style:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number,dx:_react.PropTypes.number,dy:_react.PropTypes.number,datum:_react.PropTypes.object,data:_react.PropTypes.array,index:_react.PropTypes.number,width:_react.PropTypes.number,height:_react.PropTypes.number,orientation:_react.PropTypes.oneOf(["top","bottom","left","right"]),pointerLength:_react.PropTypes.number,pointerWidth:_react.PropTypes.number,cornerRadius:_react.PropTypes.number,events:_react.PropTypes.object,shapeRendering:_react.PropTypes.string,role:_react.PropTypes.string};exports.default=Flyout;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/flyout.js
// module id = 1379
// module chunks = 0